module.exports = __webpack_public_path__ + "static/media/hyperledger-besu-circle.b96368c7.png";